import { useAbout } from "../../hooks/settingHooks";
import { StyledMarkdown } from "../markdown/StyledMarkdown";

interface Props {
  config: string;
}

export function AboutLoader(props: Props) {
  const { config } = props;
  const { data: about } = useAbout(config);

  return <>{about && <StyledMarkdown content={about.description} />}</>;
}
